import { SET_ERROR } from '../mutations/common.mutations';
import { FETCH_CAROUSEL_SLIDES } from '@/store/actions/carousel.actions';
import { SET_CAROUSEL_SLIDES, TRY_FETCH_CAROUSEL_SLIDES } from '@/store/mutations/carousel.mutations';
import CarouselService from '@/common/services/carousel.service';
import { getError } from '@/common/services/http.service';

const initialState = {
  entities: [],
  errors: null,
  pending: false,
  loaded: false,
};

const state = {
  ...initialState
};

const actions = {
  [FETCH_CAROUSEL_SLIDES](context) {
    return new Promise((resolve, reject) => {
      context.commit(TRY_FETCH_CAROUSEL_SLIDES);

      CarouselService.getSlides()
        .then(data => {
          context.commit(SET_CAROUSEL_SLIDES, data);
          resolve(data);
        })
        .catch(response => {
          context.commit(SET_ERROR, getError(response));
          reject('Error loading carousel slides');
        });
    });
  }
};

const mutations = {
  [TRY_FETCH_CAROUSEL_SLIDES](state) {
    state.errors = [];
    state.pending = true;
    state.loaded = false;
  },
  [SET_CAROUSEL_SLIDES](state, carouselSlides) {
    state.entities = carouselSlides;
    state.pending = false;
    state.loaded = true;
  },
  [SET_ERROR](state, errors) {
    state.pending = false;
    state.errors = errors;
    state.loaded = false;
  },
};

const getters = {
  carouselSlides(state) {
    return state.entities;
  },
  carouselSlidesLoaded(state) {
    return state.loaded;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
